export default "__VITE_ASSET__DbiPH0yq__"